module.exports = __webpack_public_path__ + "img/unilorin-logo.bf832f72.png";